<template>
  <div>
    <v-row class="mx-4">
      <v-col cols="12" md="4">
        <h2 class="text-left">Leave Account Details</h2>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row class="ma-2" no-gutters>
      <v-col cols="12">
        <v-card class="ma-5 pa-4">
          <v-row>
            <!-- col for staff names dropdown -->
            <v-col cols="12" md="4" class="my-1">
              <div>
                <v-autocomplete
                  dense
                  filled
                  rounded
                  solo
                  :items="ownView"
                  item-value="id"
                  item-text="full_name"
                  label="Select Staff"
                  v-model="currentStaff"
                  class="mt-4 font-weight-bold"
                  hide-details
                  return-object
                  @change="getStaffLeaveDetails();handleTourAfterClick();"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.full_name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="
                            data.item.username +
                            (data.item.employee_id
                              ? ` (${data.item.employee_id})`
                              : '')
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </div>
            </v-col>

            <v-spacer></v-spacer>

            <!-- col for tooltips -->
            

            <v-spacer></v-spacer>

            <!-- col for Apply leave btn -->
            <v-col cols="12" md="4" sm="3" class="center-text" v-if="currentUser.privileges.canApplyLeaveForSelf && (currentUser.privileges.canApplyLeaveForAnyStaff ? true : ( currentStaff.id == currentUser.id ? true : false))">
              <v-btn
                v-if="Object.keys(currentStaff).length"
                rounded
                color="primary"
                dark
                class="white--text my-6"
                :disabled="!allLeaveAllowances.length"
                :to="{ name: 'ApplyLeave', query: {staff_id: currentStaff.id} }"
                id="apply-leave-details"
              >
                Apply Leave
              </v-btn>
            </v-col>
          </v-row>

          <!-- row for leave-type cards -->
             <h4 class="mb-2" v-if="allLeaveAllowancesLoaded && !allLeaveAllowances.length">Attendance Category has not been assigned to this staff. Please do so in Staff Settings.</h4>

          <v-row v-if="Object.keys(currentStaff).length" id="leave-type-row">

            <v-col v-for="leaveAllowance in allLeaveAllowances" :key="leaveAllowance.id" cols="6" md="2">
              <v-card>
                <v-card-title class="text-left black--text card-title"
                  ><p>{{ leaveAllowance.leave_type.title }}</p></v-card-title
                >
                <v-card-subtitle class="text-left black--text">
                  <span class="mb-4">Total: <b>{{ leaveAllowance.allowed_days }}</b></span><br/>
                  Available: <b>{{ leaveAllowance.balance }}</b>
                </v-card-subtitle>

              </v-card>
            </v-col>
          </v-row>

          <!-- header and tabs row -->
          <v-row class="my-3" v-if="Object.keys(currentStaff).length && currentUser.privileges.canApproveLeaveForAllStaff">
           <!-- container for pending leaves -->
           <v-container v-if="Object.keys(currentStaff).length">
            
            <!-- row for leave cards by iteration -->
            <v-row>
              <h3 v-if="pendingLeaves.length" class="ml-4">Pending Approvals</h3>
              <v-col cols="12" v-for="(leave, i) in pendingLeaves" :key="i">
                <!-- card start -->
                <v-card color="grey lighten-4" class="pa-3 mx-4">
                  <v-row class="pa-3">
                    <!-- col for date display -->
                    <v-col cols="6" md="3" align-self="center">
                      <v-row
                        class="blue--text text--darken-2 font-weight-bold"
                        justify="center"
                      >
                        <!-- 06 Apr, Tue -->
                        {{
                          leave.start_date
                            ? moment(leave.start_date).format("LL (ddd)")
                            : "-"
                        }}
                      </v-row>
                      <div v-if="leave.start_date !== leave.end_date">
                        <v-row class="text-align-center my-3" justify="center">
                          to
                        </v-row>
                        <v-row
                          class="blue--text text--darken-2 font-weight-bold"
                          justify="center"
                        >
                          <!-- 07 Apr, Wed -->
                          {{
                            leave.end_date
                              ? moment(leave.end_date).format("LL (ddd)")
                              : "-"
                          }}
                        </v-row>
                      </div>
                      <div v-else>
                         <v-row class="text-align-center pt-3" justify="center">
                          {{leave.duration}}
                        </v-row>
                      </div>
                    </v-col>

                    <v-divider light vertical class="blue"></v-divider>

                    <!-- col for leave type & days -->
                    <v-col cols="5" md="2" align-self="center" class="mx-1">
                      <v-row justify="center" class="my-1">
                        <b>
                          <!-- Casual Leave -->
                          {{ leave.leave_type.title }}
                        </b>
                      </v-row>
                      <v-row justify="center" class="my-1">
                        <!-- 2 Day(s) -->
                        {{ leave.total_days }} Day(s)
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3">
                        <div class="my-4">
                            <!-- Casual Leave -->
                                <b>Note:</b> {{ leave.notes }}
                      </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <!-- col for status and display field -->
                    <v-col cols="12" md="3" align-self="center">
                      <v-row justify="center">
                        <div>

                          <v-select
                            dense
                            filled
                            rounded
                            solo
                            v-model="leave.approved"
                            item-text="status"
                            item-value="value"
                            :items="leaveStatusOptions"
                            label="Status"
                            class="mt-4 font-weight-bold rounded-input"
                            outlined
                            persistent-hint
                            :hint="leave.acted_by == null || leave.acted_on == null ? '' : `By ${leave.acted_by.full_name} on ${moment(leave.acted_on).format('LL')}`"
                            @change="showChangeDialog = true; changedListName = 'Pending'; toBeChangedLeave = leave"
                          >
                          </v-select>

                        </div>

                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                
              </v-col>
            </v-row>
          </v-container>


            <!-- tabs column -->
            <v-col cols="12" v-if="(upcomingLeaves.length || historyLeaves.length)">
              <div class="align-items-center">
                <!-- view tabs -->
                <v-tabs  center-active centered v-model="activeTab.key">
                  <v-tab @click="changeTab(0)" key="upcoming"> Upcoming </v-tab>
                  <v-tab @click="changeTab(1)" key="history"> History </v-tab>
                </v-tabs>
              <div class="mt-3" v-if="activeTab.key == 1 && Object.keys(currentStaff).length">
                <!-- get previous month btn -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                      @click="decrement"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                  </template>
                  <span>Previous Month</span>
                </v-tooltip>

                <!-- month, year display -->
                <span class="primary--text mx-n2"
                  ><b
                    >{{
                      moment(currentMonth, "MM").format("MMMM")
                    }}, {{ currentYear }}
                  </b></span
                >

                <!-- get next month btn -->
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="increment"
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </template>
                  <span>Next Month</span>
                </v-tooltip>
              </div>
              </div>
            </v-col>
          </v-row>
            

          <!-- container for all cards -->
          <v-container v-if="Object.keys(currentStaff).length && (upcomingLeaves.length || historyLeaves.length) && currentUser.privileges.canApproveLeaveForAllStaff">
            
            <!-- row for leave cards by iteration -->
            <v-row justify="center">
              <p class="text-center" v-if="activeTab.key == 0 ? !upcomingLeaves.length : !historyLeaves.length">No data available</p>
              <v-col cols="12" v-for="(leave, i) in activeTab.key == 0 ? upcomingLeaves : historyLeaves" :key="i" align-self="center">
                <!-- card start -->
                <v-card color="grey lighten-4" class="ma-3">
                  <v-row class="pa-3">
                    <!-- col for date display -->
                    <v-col cols="6" md="3" align-self="center">
                      <v-row
                        class="blue--text text--darken-2 font-weight-bold"
                        justify="center"
                      >
                        <!-- 06 Apr, Tue -->
                        {{
                          leave.start_date
                            ? moment(leave.start_date).format("LL (ddd)")
                            : "-"
                        }}
                      </v-row>
                       <div v-if="leave.start_date !== leave.end_date">
                        <v-row class="text-align-center my-3" justify="center">
                          to
                        </v-row>
                        <v-row
                          class="blue--text text--darken-2 font-weight-bold"
                          justify="center"
                        >
                          <!-- 07 Apr, Wed -->
                          {{
                            leave.end_date
                              ? moment(leave.end_date).format("LL (ddd)")
                              : "-"
                          }}
                        </v-row>
                      </div>
                      <div v-else>
                         <v-row class="text-align-center pt-3" justify="center">
                          {{leave.duration}}
                        </v-row>
                      </div>
                    </v-col>

                    <v-divider light vertical class="blue"></v-divider>

                    <!-- col for leave type & days -->
                    <v-col cols="5" md="2" align-self="center" class="mx-2">
                      <v-row justify="center" class="my-1">
                        <b>
                          <!-- Casual Leave -->
                          {{ leave.leave_type.title }}
                        </b>
                      </v-row>
                      <v-row justify="center" class="my-1">
                        <!-- 2 Day(s) -->
                        {{ leave.total_days }} Day(s)
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="3" align-self="center">
                      <div class="my-4">
                      <!-- Casual Leave -->
                        <b>Note:</b> {{ leave.notes }}
                      </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <!-- col for status and display field -->
                    <v-col cols="12" md="3" align-self="center">
                      <v-row justify="center">
                        <div>
                          <v-select
                            dense
                            filled
                            rounded
                            solo
                            v-model="leave.approved"
                            item-text="status"
                            item-value="value"
                            :items="leaveStatusOptions"
                            label="Status"
                            class="font-weight-bold rounded-input mx-2 mt-2"
                            :disabled="leave.approved === false || activeTab.key == 1"
                            outlined
                            hide-details="auto"
                            :persistent-hint="leave.acted_by != null && leave.acted_on != null"
                            :hint="`By ${leave.acted_by.full_name} on ${moment(leave.acted_on).format('LL')}`"
                            @change="showChangeDialog = true; changedListName = 'Upcoming'; toBeChangedLeave = leave;"
                          >
                          </v-select>

                          <hr v-if="leave.reason" class="mx-3 grey"/>

                          <div v-if="leave.approved === false && leave.reason" class="my-1">
                            <span class="font-weight-medium">
                              Reason: {{ leave.reason }}
                            </span>
                          </div>

                        </div>
                        
                      </v-row>

                    </v-col>

                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDialog
        title="Are you sure you want to change the status of this leave?"
        :description="toBeChangedLeave && (toBeChangedLeave.approved === false || moment(toBeChangedLeave.end_date).isBefore(moment())) ? 'You won\'t be able to undo this action' : null"
        successText="Proceed"
        @successCallback="changeLeaveStatus"
        :disableSuccessButton="toBeChangedLeave && !reasonFormValid && toBeChangedLeave.approved === false"
        failureText="Cancel"
        @failureCallback="closeChangeDialog"
        :visible="showChangeDialog">
        <v-form v-model="reasonFormValid" @submit.prevent>
          <v-text-field
              v-if="toBeChangedLeave && toBeChangedLeave.approved === false"
              v-model="toBeChangedLeave.reason"
              class="rounded-input mx-5"
              outlined
              dense
              :rules="[rules.required]"
              placeholder="Reason for rejection"
            />
        </v-form>
        
    </ConfirmationDialog>

    <!-- snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      timeout="5000"
      :color="snackbar.color"
      multi-line
    >
      {{ snackbar.text}}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
    
  </div>
</template>

<script>
import moment from "moment";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import Helper from '@utils/misc';
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import TourHelper from "@utils/tour_helper";

export default {
    name: "LeaveDetails",
    props: {
        month: {
            default: () => moment().month(),
            type: Number,
        },
        year: {
            default: () => moment().year(),
            type: Number,
        },
  },
  components: {
    ConfirmationDialog: ConfirmationDialog,
  },
  data() {
    return {
      moment: moment,
      currentMonth: null,
      currentYear: null,
      // leave status options
      leaveStatusOptions: [
        {
          status: 'Pending',
          value: null,
        },
        {
          status: 'Approved',
          value: true,
        },
        {
          status: 'Rejected',
          value: false,
        },
      ],
      allLeaveAllowances: [],
      allLeaveAllowancesLoaded: false,
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },

      // dummy leave types
      leaveTypeNames: [
        "Casual Leave",
        "Sick Leave",
        "Earned Leave",
        "Unpaid Leave",
        "Paternity Leave",
        "Sabbatical Leave",
      ],

      // dialog data
      showChangeDialog: false,
      changedListName: null,
      toBeChangedLeave: null,
      reasonFormValid: false,

      upcomingLeaves: [],
      historyLeaves: [],
      pendingLeaves: [],

      activeTab: {
        leaves: [],
        key: "",
      },
      

      allStaff: [],
      currentStaff: {}, // store current staff details
      rules: {
        required: (v) => !!v || "Required",
      }
    };
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },

    ownView(){
      if(this.allStaff.length == 0) return [];
      if(!this.currentUser.privileges.canViewAllStaffsLeaveAccountDetails){
        return this.allStaff.filter(x => x.id == this.currentUser.id);
      }else
      return this.allStaff;
    },


  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Staff Leave Accounts Details", description: "View your different leave types currently available in this section", videoLink: "https://youtube.com"});
        TourHelper.startTour(this, "leave__accounts__details", steps);
    },

    handleTourAfterClick() {
        var steps = [];
        steps.push({id: '1', description: "Check your current balance of leaves with leave types in a card which shows Total and Available balance."});
        steps.push({id: '2', description: "After Checking your current balance of leave, you can apply for leave from apply leave section", el: '#apply-leave-details'});
        TourHelper.startTour(this, "leave__accounts__details__after__click", steps);
    },

    // go to next month
    increment() {
      var incremented_date = moment(
        this.currentYear + "/" + this.currentMonth,
        "YYYY/MM"
      ).add(1, "month");
      this.currentMonth = Number(incremented_date.format("M"));
      this.currentYear = incremented_date.year();
      this.getHistoryLeaves();

    },

    // go to prev month
    decrement() {
      var decremented_date = moment(
        this.currentYear + "/" + this.currentMonth,
        "YYYY/MM"
      ).subtract(1, "months");
      this.currentMonth = Number(decremented_date.format("M"));
      this.currentYear = decremented_date.year();
      this.getHistoryLeaves();
    },

    changeTab(tab) {
        if(tab == 0){
            this.activeTab.leaves = this.upcomingLeaves;
        }else {
            this.activeTab.leaves = this.historyLeaves;
        }
    },

    // get all leave stats for staff
    // getLeaveStats() {

    // },

    // get staff details
    async getAllStaff() {
      var url = Helper.addUrlParams(endpoints.getAllStaff, "all=true");
      this.allStaff = await api.call(this.apiEssentials, url);
    },

    async getStaffLeaveDetails() {
        this.getUpcomingLeaves();
        this.getPendingLeaves();
        this.getAllLeaveAllowances();
        this.getHistoryLeaves();
        this.$router.push({name:"LeaveDetails", query: {staff_id: this.currentStaff.id}});

    },

    async getPendingLeaves() {
       var url = Helper.addUrlParams(endpoints.staffLeaves, ["staff_id=" + this.currentStaff.id, "pending=true", "disable_pagination=true"]);
        var response = await api.call(this.apiEssentials, url);
        if(response){
            this.pendingLeaves = response;
            this.pendingLeaves.map(l => this.$set(l, 'showChangeDialog', false));
        }
    },

    async getUpcomingLeaves() {
        var url = Helper.addUrlParams(endpoints.staffLeaves, ["staff_id=" + this.currentStaff.id, "upcoming=true", "disable_pagination=true"]);
        var response = await api.call(this.apiEssentials, url);
        if(response){
            this.upcomingLeaves = response;
        }
    },

    async getHistoryLeaves() {
      // get this month's and year's history leaves
      var url = Helper.addUrlParams(endpoints.staffLeaves, ["staff_id=" + this.currentStaff.id, "history=true", "disable_pagination=true", `month=${this.currentMonth}`, `year=${this.currentYear}`]);
      this.historyLeaves = await api.call(this.apiEssentials, url);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.color= "red";
        this.snackbar.visible = true;
      }
    },
    
    async getAllLeaveAllowances() {
        var response = await api.call(this.apiEssentials, Helper.addUrlParams(endpoints.getAllStaffLeaveAllowances, `staff_id=${this.currentStaff.id}`));
        if(response){
            this.allLeaveAllowances = response;
            this.allLeaveAllowancesLoaded = true;
        }
    },

    // // async showChangeLeaveDialog(newStatus, leave) { 
    // //   this.dialog.showChangeLeaveStatusConfirmationDialog = true; 
    // //   console.log(newStatus, leave);
    // //   this.dialog.leave_id = leave.id; 
    // //   this.dialog.status = leave.approved;
    // //   this.dialog.futureStatus = newStatus;
    // // },

    async closeChangeDialog() {
      if (this.changedListName == "Pending") this.getPendingLeaves();
      else this.getUpcomingLeaves();
      this.showChangeDialog = false;
      this.changedListName = null;
      
    },

    async changeLeaveStatus() {
      var body = {
        status: this.toBeChangedLeave.approved,
        reason: this.toBeChangedLeave.approved == false ? this.toBeChangedLeave.reason : "",
        leave_id: this.toBeChangedLeave.id
      };
      var response = await api.call(this.apiEssentials, endpoints.changeLeaveStatus, api.Methods.POST, body);
      this.showChangeDialog = false;
      this.toBeChangedLeave = this.changedListName = null;
      if(response) {
        
        this.getPendingLeaves();
        this.getUpcomingLeaves();
        this.getHistoryLeaves();
        // moved to history
        if (response.approved === false) this.snackbar.text=  "Status has been successfully changed to 'REJECTED'";
        else this.snackbar.text = `Status has been successfully changed and leave has been moved to ${response.approved == null ? 'PENDING' : moment(response.end_date).isBefore(moment()) ? 'HISTORY' : 'UPCOMING'}!`;
        this.snackbar.color = "green";
        this.snackbar.visible = true;
      }
    }
  },

  async created() {
    // get staff details through api
    await this.getAllStaff();

    this.currentMonth = this.month;
    this.currentYear = this.year;

    if(Object.prototype.hasOwnProperty.call(this.$route.query,'staff_id')){
      if(!this.currentUser.privileges.canViewAllStaffsLeaveAccountDetails && this.$route.query.staff_id != this.currentUser.id){
        this.$router.push({'name': 'LeaveDetails', 'query': {'staff_id': this.currentUser.id}})
        return;
      }
        this.currentStaff = this.allStaff.find(s => s.id == this.$route.query.staff_id);
        
        if(this.currentStaff) {
            this.getStaffLeaveDetails();
        }
    }

    // initially keep leaves of upcoming tab active
    this.activeTab.leaves = this.upcomingLeaves;
    this.handleTour();
  },
};
</script>

<style scoped>
.card-title {
  font-size: 14.5px;
  text-decoration: underline;
}

.rounded-input {
  border-radius: 12px !important;
}
</style>